import React from "react";
import * as constants from '../../constants';
import CPSettingText from "../../../../../UI/Settings/CPSettingText";
import CPSettingToggle from "../../../../../UI/Settings/CPSettingToggle";

const FirstScreen = (
    {
        eventSettings,
        accessPreModeration,
        onChange
    }
) => {
    return (
        <>
            <p style={{fontStyle: 'italic'}}>
                {constants.PLACEHOLDERS_HINT}
            </p>
            <CPSettingText
                eventSetting={eventSettings}
                title="Заголовок"
                property={constants.WIDGET_FIRST_SCREEN_TITLE}
                toggleProperty={constants.WIDGET_FIRST_SCREEN_TITLE_HIDDEN}
                defaultValue="Регистрация"
                onUpdate={onChange}
            />
            <CPSettingText
                eventSetting={eventSettings}
                title="Подзаголовок"
                property={constants.WIDGET_FIRST_SCREEN_SUBTITLE}
                toggleProperty={constants.WIDGET_FIRST_SCREEN_SUBTITLE_HIDDEN}
                rows={4}
                onUpdate={onChange}
            />
            <CPSettingText
                eventSetting={eventSettings}
                title="Текст в кнопке"
                property={constants.WIDGET_FIRST_SCREEN_BUTTON_TEXT}
                hasToggleProperty={false}
                rows={1}
                defaultValue={constants.DEFAULT_BUTTON_REGISTRATION_TEXT(accessPreModeration)}
                onUpdate={onChange}
            />
            <CPSettingToggle
                name={constants.WIDGET_DISCLAIMER_CHECKED}
                isChecked={eventSettings?.[constants.WIDGET_DISCLAIMER_CHECKED]}
                label="Автоматически проставлять галочки в дисклеймерах"
                onChange={onChange}
            />
        </>
    );
};

export default FirstScreen;
